export const TEXT_CHARACTER_LIMIT = 3000;
export const CONTACT_CHARACTER_LIMIT = 500;
export const ADDRESS_CHARACTER_LIMIT = 500;
export const DEFAULT_BLOCK_ICON = 'stop';



// WEBPACK FOOTER //
// ./src/modules/edito/constants/index.js